import React from 'react';
import PropTypes from 'prop-types';

import {TableCell, TableRow} from "@mui/material";

import FileName from "./FileName";
import ReferenceCount from "./ReferenceCount";
import RecurrenceDisplay from "./RecurrenceDisplay";
import StatusBadge from "./StatusBadge";
import LastImportedAtDate from "./LastImportedAtDate";
import FeedActions from "./FeedActions";

import {greyishBlue50} from "assets/jss/main";

DemoFeedTableRow.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        '@id': PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        transportType: PropTypes.string.isRequired,
        name: PropTypes.string,
        process: PropTypes.string,
        lastImportedAt: PropTypes.string,
        lastImportReport: PropTypes.object,
        variationReferenceCountVariationPercentage: PropTypes.number,
        mapper: PropTypes.string,
        recurrence: PropTypes.number.isRequired,
        recurrenceUnit: PropTypes.string.isRequired,
    }).isRequired,
};

function DemoFeedTableRow({feed}) {
    return (
        <TableRow
            sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '&:hover': { backgroundColor: greyishBlue50 },
            }}
        >
            <TableCell component="th" scope="row">
                {feed.id.substring(0, 8)}
            </TableCell>
            <TableCell component="th" scope="row">
                <FileName feed={feed} />
            </TableCell>
            <TableCell component="th" scope="row">
                <ReferenceCount
                    importReport={feed.lastImportReport}
                    variationPercentage={feed.variationReferenceCountVariationPercentage}
                />
            </TableCell>
            <TableCell component="th" scope="row">
                <RecurrenceDisplay
                    recurrence={feed.recurrence}
                    recurrenceUnit={feed.recurrenceUnit}
                    lastImportedAt={feed.lastImportedAt}
                />
            </TableCell>
            <TableCell component="th" scope="row">
                <StatusBadge process={feed.process} hasErrors={feed.lastImportReport?.nbErrors > 0} />
            </TableCell>
            <TableCell component="th" scope="row">
                <LastImportedAtDate date={feed.lastImportedAt} />
            </TableCell>
            <TableCell align="right">
                <FeedActions feed={feed}/>
            </TableCell>
        </TableRow>
    );
}

export default DemoFeedTableRow;
